import React from 'react'

const NoUpsell = () => {
  return (
    <div>NoUpsell</div>
  )
}

export default NoUpsell